import { addMonths, eachDay, endOfWeek, startOfWeek, subMonths } from 'date-fns'
import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import DateFormatter from '../DateFormatter'
import { Day, IconButton, Picker, WeekDays } from './styled'

function MonthPicker({
  date,
  change,
  sized,
}: IMonthPickerProps & IMonthPickerDispatch) {
  function moveForward() {
    change(addMonths(date, 1))
  }

  function moveBackward() {
    change(subMonths(date, 1))
  }

  return (
    <React.Fragment>
      <Picker>
        <IconButton onClick={moveBackward} left={true}>
          <FiChevronLeft />
        </IconButton>
        <DateFormatter date={date} dateFormat={'MMM'} />
        <IconButton onClick={moveForward} right={true}>
          <FiChevronRight />
        </IconButton>
      </Picker>
      {!sized && (
        <WeekDays>
          {eachDay(
            startOfWeek(date, { weekStartsOn: 1 }),
            endOfWeek(date, { weekStartsOn: 1 }),
          ).map((day: Date, index: number) => (
            <Day key={index}>
              <DateFormatter date={day} dateFormat={'dd'} />
            </Day>
          ))}
        </WeekDays>
      )}
    </React.Fragment>
  )
}

export default MonthPicker

export interface IMonthPickerProps {
  date: Date
  sized: boolean
}

export interface IMonthPickerDispatch {
  change?: (date: Date) => void
}
